//angular imports
import { ChangeDetectionStrategy, Component, signal, WritableSignal } from '@angular/core';

//local imports
import { ProjectModel } from '@app/catalog';
import { PresenterType } from '@app/shared';



@PresenterType({
  model: ProjectModel,
  key: 'tileTop'
})
@Component({
  selector: 'app-project-carousel-item',
  templateUrl: './project-carousel-item.component.html',
  styleUrl: './project-carousel-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ProjectCarouselItemComponent {
  public data: WritableSignal<ProjectModel> = signal<ProjectModel>(undefined);
}
